class BanglaUtils {

    static numbers = {
        '০': 0,
        '১': 1,
        '২': 2,
        '৩': 3,
        '৪': 4,
        '৫': 5,
        '৬': 6,
        '৭': 7,
        '৮': 8,
        '৯': 9
    };

    static numbersBn = {
      '0': '০',
      '1': '১',
      '2': '২',
      '3': '৩',
      '4': '৪',
      '5': '৫',
      '6': '৬',
      '7': '৭',
      '8': '৮',
      '9': '৯'
  };

    static banglaToEnglishNumber(input) {
      input = String(input);
      
      var output = [];
      for (var i = 0; i < input.length; ++i) {
        if (Object.prototype.hasOwnProperty.call(BanglaUtils.numbers,input[i])) {
        // if (BanglaUtils.numbers.hasOwnProperty(input[i])) {
          output.push(BanglaUtils.numbers[input[i]]);
        } else {
          output.push(input[i]);
        }
      }
      let str = output.join('');
      // console.log(str);
      if (isNaN(str))
        return 0;
      
      return (str);
      // return Number(str);
    }

    static englishToBanglaNumber(input) {
      input = String(input);
      var output = [];
      for (var i = 0; i < input.length; ++i) {
          if (Object.prototype.hasOwnProperty.call(BanglaUtils.numbersBn,input[i])) {
          // if (BanglaUtils.numbersBn.hasOwnProperty(input[i])) {
              output.push(BanglaUtils.numbersBn[input[i]]);
          } else {
              output.push(input[i]);
          }
      }
      let str = output.join('');
      return str;
  }
}

export { BanglaUtils };
